import { ReferrerKindEnum } from '@clickersphere/core/enums/ReferrerKindEnum';

export const referrerKindLabelKeys = {
  [ReferrerKindEnum.DOULA]: 'referrer.kind.DOULA',
  [ReferrerKindEnum.OBSTETRICIAN]: 'referrer.kind.OBSTETRICIAN',
  [ReferrerKindEnum.NURSE]: 'referrer.kind.NURSE',
  [ReferrerKindEnum.MATERNITY]: 'referrer.kind.MATERNITY',
  [ReferrerKindEnum.OTHER]: 'referrer.kind.OTHER',
} as const satisfies Record<ReferrerKindEnum, string>;
